/* Example feature: shows the pattern every feature follows. Hidden unless the URL has ?examples=1
   (folders starting with "_" are skipped by the loader). Copy this folder to start a feature. */
import { lazy } from 'react';
import { FlaskConical } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: '_example',
  title: 'Example chat',
  short: 'Example',
  icon: FlaskConical,
  group: 'Work',
  route: '/example',
  order: 999,
  rail: true,
  bottom: true,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [{ id: 'replay', title: 'Example: replay the recorded run', to: '/example?replay=1', keywords: ['demo', 'stream'] }],
  capabilities: ['CHAT-01', 'CHAT-02', 'CHAT-03', 'AGENT-01', 'AGENT-12', 'SEARCH-01', 'SEARCH-04', 'BUILD-01'],
});
